export default __webpack_public_path__ + "static/media/group.984613e7.jpg";